import styled from '@emotion/styled';
import { Pagination } from '@blueprint/ui';
import { css } from '@emotion/react';
import { breakpoints } from '../common/constants';

export const sidebarBreakpoint = `@media only screen and (min-width: ${breakpoints.lsrpSidebar}px)`;

export const getRems = (pixels: number) => {
    return `${pixels / 16}rem`;
};

const tempLargerBreakPoint = '@media only screen and (min-width: 1140px)';

const SearchResultsWrapper = styled.div(
    ({ theme: { colors } }) => css`
        width: 100%;
        margin: 0 auto;
        background-color: ${colors['graphic-background']};
    `
);

const InnerWrapper = styled.div(
    ({ theme: { spacing, mq, pageWidth } }) => css`
        margin: 0 auto;
        padding: ${spacing['8px']} 0;

        ${mq.medium} {
            padding: ${spacing['24px']} 0;
        }
        padding: ${spacing['24px']} 0;
        max-width: calc(${pageWidth}px + (2 * ${spacing['32px']}));

        ${sidebarBreakpoint} {
            display: flex;
        }
    `
);

const DesktopSubHeaderWrapper = styled.div(
    ({ theme: { colors, spacing } }) => css`
        width: 100%;
        color: ${colors['white']};
        display: none;
        padding: ${spacing['16px']} 0;
        justify-content: center;

        ${tempLargerBreakPoint} {
            display: flex;
        }
    `
);

export const SearchInputWrapper = styled.div(
    ({ theme: { spacing, pageWidth } }) => css`
        padding: 0;
        display: flex;
        width: 100%;
        max-width: calc(${pageWidth}px + (2 * ${spacing['32px']}));
        padding: 0 ${spacing['32px']};
    `
);

const SideBar = styled.aside(
    ({ theme: { spacing, mq } }) => css`
        display: block;
        min-width: ${getRems(299)};
        padding: 0 ${spacing['16px']};

        ${mq.large} {
            padding: 0 ${spacing['32px']};
        }

        ${sidebarBreakpoint} {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            align-content: flex-start;
            padding: 0;
            margin-right: ${spacing['32px']};
            max-width: ${getRems(300)};
        }
    `
);

const SectionThatDisappearsWhenNoSideBar = styled.div<{ minWidth?: string }>(
    ({ minWidth }) => css`
        display: none;

        ${sidebarBreakpoint} {
            display: block;
            min-width: ${minWidth || getRems(299)};
        }
    `
);

const SectionThatAppearsWhenNoSideBar = styled.div(
    () => css`
        ${sidebarBreakpoint} {
            display: none;
        }
    `
);

const SearchResultsLayoutGroup = styled.div(
    ({ theme: { spacing, mq } }) => css`
        margin-bottom: ${spacing['16px']};
        padding: 0 ${spacing['16px']};

        ${mq.large} {
            margin-bottom: ${spacing['24px']};
            padding: 0 ${spacing['32px']};
        }
    `
);

const PaginationContainer = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: center;
        margin-top: ${spacing['24px']};
    `
);

const StyledPagination = styled(Pagination)(
    () => css`
        flex-grow: 1;
    `
);

const StyledMobileQuickSearchBar = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        padding-top: ${spacing['8px']};
    `
);
const StickyQuickSearchBarDynamicShadow = styled.div(
    () => css`
        height: 5rem;
        position: sticky;
        top: -1rem;
        z-index: 4;
        text-align: center;
        -webkit-backface-visibility: hidden;

        ${tempLargerBreakPoint} {
            display: none;
        }

        &::before,
        &::after {
            content: '';
            display: block;
            height: 1rem;
            position: sticky;
            -webkit-position: sticky;
        }

        &::before {
            top: 3rem;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25),
                0px 3px 12px rgba(38, 38, 48, 0.2), inset 0px -1px 0px #dcdcef;
        }
    `
);

const StickyQuickSearchBarWrapper = styled.div(
    ({ theme: { colors, spacing } }) => css`
        background-color: ${colors['graphic-background']};
        height: 4rem;
        padding-bottom: ${spacing['8px']};
        position: sticky;
        top: 0;
        margin-top: -1rem;
        z-index: 6;

        ${tempLargerBreakPoint} {
            display: none;
        }
    `
);

const LocationWrapper = styled.div(
    () => css`
        flex-grow: 1;
        min-width: 0;
    `
);

export {
    SearchResultsWrapper,
    SideBar,
    SectionThatDisappearsWhenNoSideBar,
    SectionThatAppearsWhenNoSideBar,
    DesktopSubHeaderWrapper,
    InnerWrapper,
    SearchResultsLayoutGroup,
    PaginationContainer,
    StyledPagination,
    StyledMobileQuickSearchBar,
    LocationWrapper,
    StickyQuickSearchBarWrapper,
    StickyQuickSearchBarDynamicShadow
};
